import { Download } from "components/icons/generated";
import Button from "ds/components/Button";
import { DateRange } from "ds/components/Datepicker/types";

import { CSVDownloadAspect } from "../types";
import { showCSVDownloadDrawer } from "./Drawer";

type CSVDownloadDrawerButtonProps = {
  aspectType: CSVDownloadAspect;
  initialRange?: DateRange;
};

const CSVDownloadDrawerButton = ({ aspectType, initialRange }: CSVDownloadDrawerButtonProps) => (
  <Button
    variant="secondary"
    startIcon={Download}
    onPress={() => showCSVDownloadDrawer({ aspectType, initialRange })}
  >
    Export CSV
  </Button>
);

export default CSVDownloadDrawerButton;
